var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('button',{staticClass:"nugget",on:{"click":_vm.handle}},[_vm._v("Nugget")]),_c('text-dialog',{ref:"textDialogue"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }